module.exports = __webpack_public_path__ + "static/3-c16d43ae9bc1b02cb594a2836663db51.jpeg";